import { Inventaraufstellung } from '@gsm/entities';
import { DynamicFormControlLayout, DynamicFormValueControlModel, DynamicFormValueControlModelConfig, serializable } from '@ng-dynamic-forms/core';

export const TYPE_INVENTARAUFSTELLUNG_TABLE = 'INVENTARAUFSTELLUNG_TABLE';

export interface InventaraufstellungTableModelConfig extends DynamicFormValueControlModelConfig<Inventaraufstellung> {
}

export class InventaraufstellungTableModel extends DynamicFormValueControlModel<Inventaraufstellung> {
  @serializable() readonly type: string = TYPE_INVENTARAUFSTELLUNG_TABLE;

  constructor(config: InventaraufstellungTableModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);
  }
}
